
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

interface BankDetails {
  beneficiaryName: string;
  bankName: string;
  routingNumber: string;
  accountNumber: string;
  otherDetails: string;
}

interface BankTransferFormProps {
  bankDetails: BankDetails;
  setBankDetails: (details: BankDetails) => void;
}

export const BankTransferForm = ({
  bankDetails,
  setBankDetails,
}: BankTransferFormProps) => {
  return (
    <div className="space-y-4 border rounded-lg p-4 bg-gray-50">
      <h4 className="font-medium">Bank Transfer Details</h4>
      
      <div className="space-y-2">
        <label className="block text-sm font-medium text-gray-700">
          Beneficiary Name
        </label>
        <Input
          value={bankDetails.beneficiaryName}
          onChange={(e) => setBankDetails({
            ...bankDetails,
            beneficiaryName: e.target.value
          })}
          placeholder="Enter beneficiary name"
        />
      </div>

      <div className="space-y-2">
        <label className="block text-sm font-medium text-gray-700">
          Bank Name
        </label>
        <Input
          value={bankDetails.bankName}
          onChange={(e) => setBankDetails({
            ...bankDetails,
            bankName: e.target.value
          })}
          placeholder="Enter bank name"
        />
      </div>

      <div className="space-y-2">
        <label className="block text-sm font-medium text-gray-700">
          Routing/ABA/Swift Number
        </label>
        <Input
          value={bankDetails.routingNumber}
          onChange={(e) => setBankDetails({
            ...bankDetails,
            routingNumber: e.target.value
          })}
          placeholder="Enter routing/ABA/Swift number"
        />
      </div>

      <div className="space-y-2">
        <label className="block text-sm font-medium text-gray-700">
          Account Number
        </label>
        <Input
          value={bankDetails.accountNumber}
          onChange={(e) => setBankDetails({
            ...bankDetails,
            accountNumber: e.target.value
          })}
          placeholder="Enter account number"
        />
      </div>

      <div className="space-y-2">
        <label className="block text-sm font-medium text-gray-700">
          Other Details
        </label>
        <Textarea
          value={bankDetails.otherDetails}
          onChange={(e) => setBankDetails({
            ...bankDetails,
            otherDetails: e.target.value
          })}
          placeholder="Enter any additional details"
        />
      </div>
    </div>
  );
};
